import FluxUtils from 'flux/utils';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import WebAppsStore from 'sharedreact/stores/WebAppsStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import MainTab from 'workspaces/launcher/components/clientapps/MainTab';
import DownloadSupport from 'workspaces/launcher/utils/DownloadSupport';
import asFunctional from 'sharedreact/components/asFunctional';

type Props = {
  index: number,
  activeTab: number
};

type State = ConstructorParameters<typeof MainTab>[0];

function getStores () {
  return [
    SettingsStore,
    WebAppsStore
  ];
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  return {
    index: props.index,
    activeTab: props.activeTab,
    apps: WebAppsStore.getItems(),
    language: SettingsStore.getLanguage(),
    createDownloadUrl: DownloadSupport.createDownloadUrl
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(MainTab),
  getStores,
  calculateState,
  { withProps: true }
);
